module.exports = __webpack_public_path__ + "static/img/030_TO8_1486_og.3958f03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/030_TO8_1486_og.jpg
// module id = jK+C
// module chunks = 0